import { Component, OnChanges, inject, ChangeDetectionStrategy, input } from '@angular/core';

import {ClmPerformanceOutput} from "../../../../model/clm-performance-output";
import {ConfigurationSection, UserStateService} from "../../../../services/user-state.service";
import {MatIcon} from "@angular/material/icon";
import {ReactiveFormsModule} from "@angular/forms";

@Component({
  selector: 'app-w2w-sw-com-cooling-performance-output',
  imports: [MatIcon, ReactiveFormsModule],
  templateUrl: './w2w-sw-com-cooling-performance-output.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  styleUrl: './w2w-sw-com-cooling-performance-output.component.css'
})
export class W2wSwComCoolingPerformanceOutputComponent implements OnChanges {
  private readonly userStateService = inject(UserStateService);


  readonly results = input.required<ClmPerformanceOutput>();
  isExpanded = true;
  private sectionKey = ConfigurationSection.COOLING_PERFORMANCE_RESULTS;

  constructor() {
    this.isExpanded = !this.userStateService.isConfigurationSectionCollapsed(this.sectionKey);
  }

  ngOnChanges(): void {
  }

  toggleExpansion(): void {
    this.isExpanded = !this.isExpanded;
    this.userStateService.setCollapsedValue(this.sectionKey, this.isExpanded);
  }

  getExpansionIcon(): string {
    return this.isExpanded ? 'arrow_drop_up' : 'arrow_drop_down';
  }

  hasMessages(): boolean {
    return (this.results()?.messages?.length || 0) > 0;
  }

}
